import Vue        from 'vue'
import Vuex       from 'vuex'
import Config     from '../config/config'
import scene3D    from './modules/scenes/3d'
import scene360   from './modules/scenes/360'
import actions    from './actions'
import getters    from './getters'
import mutations  from './mutations'
import * as Three from 'three'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  state: {
    appName: Config.appName,
    scene: new Three.Scene(),
    renderer: null,
    bounds: {
      x: 200,
      y: 200,
      z: 400
    },
    move: true,
    gui: {
      showObjectEdge: true,
      showGizmos: true,
      showSceneBorders: true,
      objectEdgeSize: 8,
      gizmoSize: 64
    }
  },

  mutations: {
    setScene(state, value) {
      state.scene = value
    },
    sceneModelAdd(state, model) {
      state.scene.add(model)
    }
  },

  actions: {
  },

  modules: {
    scene3D,
    scene360
  }
})
